import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import zh from "./locales/zh";

const resources = {
  en,
  zh
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('i18nextLng') || 'zh',
  fallbackLng: "en",
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
